import { useGetAlboRecordCodiceCodice } from '@framework/common-web/register-records/frontoffice/api/albo-record-controller/albo-record-controller.ts';
import { type IVerifyPassInput } from './VerifyPassPage.tsx';

/**
 * Hook per ottenere le informazioni di un tesserino verificato
 * mediante il codice o il QR code
 */
export function useGetVerifyPassInfo(input?: IVerifyPassInput) {
  const value = input?.code;
  const normalizedValue = value?.trim().toUpperCase();

  const {
    data: codeData,
    error,
    isLoading,
  } = useGetAlboRecordCodiceCodice(normalizedValue ?? '', {
    query: { enabled: !!normalizedValue },
  });

  return {
    record: codeData,
    error,
    isLoading,
  };
}
